module.exports = __webpack_public_path__ + "static/media/Guatemala_8DOL_100Min.51a6bbd9.jpg";